export default {
  name: 'marking--treeMrkReaggregation',
  apiService: 'shoes',
  apiPath: '/admin/mrk/func/reaggr',
  urlParamName: 'marking--treeMrkReaggregation',
};